import React, { Component } from 'react';
import List from './List';
import Form from './Form';
import TabbablePage from '../../components/TabbablePage';
import DocumentTitle from 'react-document-title';

export default class Page extends React.Component {
	render() {
		return (
			<DocumentTitle title="E-maily">
				<TabbablePage
					module="email"
					List={List}
					Form={Form}
					newTitle="Nový"
					listTitle="Seznam e-mailů"
					{...this.props}
				/>
			</DocumentTitle>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Email/Page.js